/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MisconfigurationViolationsByRegionWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("MisconfigurationViolationsByRegionWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return MisconfigurationViolationsByRegionWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<MisconfigurationViolationsByRegionWidgetConfiguration>): MisconfigurationViolationsByRegionWidgetConfiguration {
        let obj = Object.assign(new MisconfigurationViolationsByRegionWidgetConfiguration(), model);
        MisconfigurationViolationsByRegionWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MisconfigurationViolationsByRegionWidgetConfiguration>): MisconfigurationViolationsByRegionWidgetConfiguration {
        if (!model) return null;
        return MisconfigurationViolationsByRegionWidgetConfiguration.newInstance(<MisconfigurationViolationsByRegionWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MisconfigurationViolationsByRegionWidgetConfiguration) {
        if (!obj) return;

        models.MisconfigurationViolationsByRegionWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MisconfigurationViolationsByRegionWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, MisconfigurationViolationsByRegionWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
